export const SET = "camera-compliance/SET";
export const RESET = "camera-compliance/RESET";
export const UPDATE = "camera-compliance/UPDATE";
export const REMOVE = "camera-compliance/DELETE";
export const RESET_REDUX = "camera-compliance/RESET_REDUX";
